import { Component, inject } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../services/toast.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [NgbToast, NgTemplateOutlet],
  template: `
    @for (toast of toastService.toasts; track toast) {
      <ng-template #successTpl>{{ toast.header }}</ng-template>
      <ngb-toast
        [class]="toast.className"
        [autohide]="true"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
      >
        <ng-template [ngTemplateOutlet]="successTpl"></ng-template>
      </ngb-toast>
    }
  `,
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-3',
    style: 'z-index: 1200',
  },
})
export class ToastsComponent {
  protected toastService = inject(ToastService);
}
